import request from '@/router/axios'

const baseUrl = '/api/produce/emergency-task'

export const getMyTaskList = (data) => {
  return request({
    url: `${baseUrl}/my-page`,
    method: 'post',
    data
  })
}

export const getTaskDetail = (id) => {
  return request({
    url: `${baseUrl}/select/id`,
    method: 'get',
    params: { id }
  })
}

export const completeTask = (data) => {
  return request({
    url: `${baseUrl}/complete`,
    method: 'post',
    data
  })
}
